import StyledIllustration from "./StyledIllustration";

interface TeamIllustrationProps {
    width?: number;
    height?: number;
}

export const TeamIllustration = (props: TeamIllustrationProps) => {
    const { width = 377, height = 300 } = props;

    return (
        <StyledIllustration
            fileName={"Team.svg"}
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="none"
            viewBox="0 0 377 300"
        >
            <g clipPath="url(#clip0_87684_112699)">
                <rect x="94" y="119" width="152" height="120" rx="7" className="Tone8 sTone1" strokeWidth="2" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M174.119 183.647C152.934 181.533 141.574 189.947 136 218.002C130.426 246.057 129.491 289.806 165.413 287.443C201.335 285.08 204.523 279.153 207 258.65C208.907 242.877 194.856 187.767 174.119 183.647Z"
                    className="Primary"
                />
                <path
                    d="M137.702 157.618C144.546 172.114 172.251 180.927 186.747 174.083C201.244 167.238 198.771 146.713 191.927 132.216C185.082 117.72 166.052 112.133 151.556 118.978C137.06 125.822 130.857 143.122 137.702 157.618Z"
                    className="Tone1"
                />
                <path
                    d="M151.556 118.978C137.06 125.822 130.857 143.123 137.701 157.619C140.456 163.453 146.591 168.364 153.883 171.707C156.812 159.869 148.284 155.826 151.24 155.631C162.321 154.903 158.955 143.553 156.486 134.754C171.345 130.591 178.617 125.23 180.843 120.27C172.208 115.273 160.942 114.547 151.556 118.978Z"
                    className="Primary"
                />
                <circle
                    cx="2.29143"
                    cy="2.29143"
                    r="1.90737"
                    transform="matrix(-0.904273 0.426954 0.426954 0.904273 185.364 136.289)"
                    className="Tone8 sTone8"
                    strokeWidth="0.768122"
                />
                <circle
                    cx="2.29143"
                    cy="2.29143"
                    r="1.90737"
                    transform="matrix(-0.904273 0.426954 0.426954 0.904273 174.696 145.109)"
                    className="Tone8 sTone8"
                    strokeWidth="0.768122"
                />
                <circle
                    cx="5.32143"
                    cy="5.32143"
                    r="5.32143"
                    transform="matrix(-0.904273 0.426954 0.426954 0.904273 155.884 150.551)"
                    className="Tone1"
                />
                <path
                    d="M184.799 155.568C193.194 155.831 192.106 148.493 185.328 148.94"
                    className="sTone8"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M180.654 165.721C176.726 168.741 171.489 167.054 170.098 164.318"
                    className="sTone8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M159.5 107.999C165.521 103.522 186.611 86.7156 190.5 105C197.754 139.097 169.99 134.369 150.223 146.192C137.846 153.595 145.302 161.99 153.742 170.956C134.304 162.38 120.328 137.133 159.5 107.999Z"
                    className="Primary"
                />
                <path
                    d="M181.768 197.529C178.324 189.862 172.935 173.397 173.165 169.645L160.204 167.14C157.759 171.06 157.391 180.957 156.994 188.693C156.912 190.286 157.89 191.746 159.399 192.264L180.136 199.386C181.184 199.746 182.222 198.54 181.768 197.529Z"
                    className="Tone1"
                />
                <path
                    d="M127 207C69.4998 215.214 68 165 105 101.999C120.003 106.744 128.5 109.499 128.5 109.499C121 124.499 82.4113 192.456 133 180.499C160.5 173.999 178.5 191.499 186.5 200.999C173.902 218.197 164.5 226 164.5 226C154.5 215 150.023 203.711 127 207Z"
                    className="Primary"
                />
                <path
                    d="M103.937 92.0762C102.702 97.8709 103.68 102.857 104.831 105.593C105.982 108.329 111.872 116.568 121.144 114.562C130.417 112.557 136.694 106.674 136.694 106.674C138.479 105.049 141.666 102.484 143.416 99.7596C144.526 98.0321 145.604 96.201 144.613 94.9807C143.081 93.0963 137.988 94.3464 134.889 96.8643C136.743 91.7914 143.579 80.8743 145.023 74.7138C145.882 71.0479 143.311 69.9657 142.252 69.8432C138.322 69.3886 133.696 79.7637 130.542 85.1836C132.095 81.1941 135.595 74.0664 137.069 69.3074C138.543 64.5484 136.51 62.0462 133.784 63.0741C130.418 64.3434 124.984 76.6701 123.388 82.7108C124.419 78.8088 126.086 73.8325 126.53 70.1556C127.685 65.0629 126.003 64.0463 124.222 63.7226C120.326 63.0146 116.778 75.8776 115.737 82.4673C116.093 80.2 115.762 80.1755 115.822 75.2964C115.866 71.6993 113.394 71.2424 111.835 71.4143C107.51 71.891 105.48 84.8328 103.937 92.0762Z"
                    className="Tone1"
                />
                <path
                    d="M116.663 89.1219C118.723 89.163 122.604 89.1551 125.509 92.7297"
                    className="sTone8"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M131.41 95.8659C128.687 96.8916 126.296 98.8876 125.631 101.155C124.966 103.423 125.64 105.977 127.607 105.69C129.574 105.402 128.489 102.159 125.574 100.035C122.659 97.9107 117.915 96.9044 112.565 101.09"
                    className="sTone8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <rect
                x="210"
                y="201.992"
                width="73.4654"
                height="56.2696"
                rx="5.48972"
                transform="rotate(-5.3899 210 201.992)"
                className="Tone1"
            />
            <circle
                cx="249.154"
                cy="226.065"
                r="13.7064"
                transform="rotate(-5.3899 249.154 226.065)"
                className="Tone8"
            />
            <path
                d="M254.336 224.252C255.402 224.74 255.54 226.199 254.584 226.878L248.133 231.461C247.177 232.14 245.845 231.53 245.734 230.363L244.991 222.484C244.881 221.317 246.076 220.468 247.142 220.957L254.336 224.252Z"
                className="Primary"
            />
            <rect
                x="226.119"
                y="46.1758"
                width="94.6032"
                height="108.658"
                rx="9.46032"
                transform="rotate(6.98288 226.119 46.1758)"
                className="Tone1"
            />
            <path
                d="M293.889 94.4179C292.303 110.37 269.158 127.964 253.206 126.378C237.254 124.792 232.699 104.626 234.285 88.6737C235.872 72.7218 251.926 61.0761 267.878 62.6623C283.829 64.2485 295.475 78.466 293.889 94.4179Z"
                className="Tone8"
            />
            <path
                d="M267.878 62.6619C283.83 64.2481 295.476 78.466 293.889 94.4179C293.251 100.838 289.119 107.523 283.37 113.117C276.64 102.945 283.31 96.2464 280.469 97.0865C267.397 100.953 258.333 92.1335 259.119 78.4851C252.783 84.69 239.182 82.4986 236.962 79.3576C242.452 68.415 255.197 61.4011 267.878 62.6619Z"
                className="Primary"
            />
            <circle
                cx="243.888"
                cy="92.8194"
                r="1.90737"
                transform="rotate(5.67865 243.888 92.8194)"
                className="Tone1 sTone1"
                strokeWidth="0.768122"
            />
            <circle
                cx="256.896"
                cy="97.546"
                r="1.90737"
                transform="rotate(5.67865 256.896 97.546)"
                className="Tone1 sTone1"
                strokeWidth="0.768122"
            />
            <circle
                cx="279.158"
                cy="99.6812"
                r="5.32143"
                transform="rotate(5.67865 279.158 99.6812)"
                className="Tone8"
            />
            <path
                d="M249.659 108.05C247.281 108.957 242.563 109.754 242.563 106.276C242.563 104.315 244.169 104.184 246.111 102.217"
                className="sTone1"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M271.406 68.8083L275.086 68.8633C286.995 48.6888 300.232 63.1589 300.232 75.5787C300.232 170.803 367.912 152.178 374.858 128.804C379.489 113.217 373.522 102.859 354.398 98.5198C329.156 92.7928 335.521 81.0016 335.732 65.5953C335.988 46.919 320.826 35.8824 306.373 34.8884C285.462 33.4502 271.072 49.8316 271.406 68.8083Z"
                className="Primary"
            />
            <path
                d="M256.142 116.46C260.855 117.988 265.224 114.642 265.616 111.598"
                className="sTone1"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M269.153 130.054C283.362 130.054 298.693 142.412 306.908 159.463C305.114 162.794 301.411 164.857 297.429 164.37L231.767 156.34C240.467 139.79 257.171 130.054 269.153 130.054Z"
                className="Primary"
            />
            <path
                d="M257.346 146.014C259.237 140.498 262.122 123.335 260.915 119.142L273.021 113.879C276.651 117.572 279.673 131.136 281.877 138.793L257.346 146.014Z"
                className="Tone8"
            />
            <rect
                x="157"
                y="30.1953"
                width="53"
                height="40"
                rx="20"
                transform="rotate(-12.1948 157 30.1953)"
                className="Tone1"
            />
            <path
                d="M199.722 69.0471L183.592 57.8594L201.462 55.7009L202.847 67.1639C203.054 68.8771 201.14 70.0306 199.722 69.0471Z"
                className="Tone1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M186.895 40.7502C186.895 40.7502 188.662 36.1786 192.129 36.1522C195.596 36.1258 198.263 40.0015 196.78 43.9556C195.438 47.535 190.633 52.4838 189.252 53.3631C189.108 53.4551 188.907 53.4986 188.679 53.477C183.973 53.0316 180.527 50.3967 178.253 47.9597C178.253 47.9597 174.484 43.2889 178.26 39.7831C182.036 36.2774 186.895 40.7502 186.895 40.7502Z"
                className="Tone8"
            />
            <defs>
                <clipPath id="clip0_87684_112699">
                    <rect width="247" height="194" fill="white" transform="translate(0 46)" />
                </clipPath>
            </defs>
        </StyledIllustration>
    );
};

export default TeamIllustration;
